
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground } from 'docz'
import Interactions from './interactions'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "interactions"
    }}>{`Interactions`}</h1>
    <hr />
    <h2 {...{
      "id": "interactions-1"
    }}>{`Interactions`}</h2>
    <Playground __position={1} __code={'<code>--ds-interactions-transition: 0.13s ease-in-out;</code>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Interactions
    }} mdxType="Playground">
  <code>
  --ds-interactions-transition: 0.13s ease-in-out;
  </code>
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;